export const gradientsTheme = colors => ({
  babies_gradient: {
    background1: colors.gradientBabies[100],
    background2: colors.gradientBabies[300],
    background3: colors.gradientBabies[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.babies[800],
    hover: colors.babies[900]
  },
  kids_gradient: {
    background1: colors.gradientKids[100],
    background2: colors.gradientKids[300],
    background3: colors.gradientKids[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.kids[800],
    hover: colors.kids[900]
  },
  tweens_gradient: {
    background1: colors.gradientTweens[100],
    background2: colors.gradientTweens[300],
    background3: colors.gradientTweens[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.tweens[800],
    hover: colors.tweens[900]
  },
  teens_gradient: {
    background1: colors.gradientTeens[100],
    background2: colors.gradientTeens[300],
    background3: colors.gradientTeens[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.teens[800],
    hover: colors.teens[900]
  },
  generic_gradient: {
    background1: colors.gradientGeneric[100],
    background2: colors.gradientGeneric[300],
    background3: colors.gradientGeneric[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.neutral[800],
    hover: colors.neutral[900]
  },
  franchises_gradient: {
    background1: colors.gradientFranquicias[100],
    background2: colors.gradientFranquicias[300],
    background3: colors.gradientFranquicias[500],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.franquicias[800],
    hover: colors.franquicias[900]
  },
  neutral_black: {
    background1: colors.neutral[1000],
    background2: colors.neutral[1000],
    background3: colors.neutral[1000],
    text: colors.neutral[100],
    color: colors.neutral[100],
    button: colors.neutral[800],
    hover: colors.neutral[900]
  },
  basic_black: {
    background: colors.white[400],
    color: colors.black[300],
    text: colors.black[300]
  },
  basic_white: {
    background: colors.black[300],
    text: colors.white[400],
    color: colors.white[400]
  }
});
